<ul class="menu-links">
  @for (link of linksGroup; track link.label) {
    <li>
      @if (link.isExternal) {
        <a [href]="link.link" [target]="link.isTargetBlank ? '_blank' : '_self'">{{ link.label }}</a>
      } @else {
        <a [routerLink]="link.link">{{ link.label }}</a>
      }
    </li>
  }
</ul>
